export const STATUS = {
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  TRIAL: 'trialing',
  PENDING: 'pending',
  CANCELED: 'canceled',
};

export const ACTIVE_STATUSES = [STATUS.ACTIVE, STATUS.PAST_DUE, STATUS.TRIAL];

//These values should just be used for promoting plans
//Anything specific to the user should come from user.rules
export const FREE = {
  TRANSFER_LIMIT: '2 GB',
};
export const FREE_ACCOUNT = {
  TRANSFER_LIMIT: '2 GB',
  STORAGE_LIMIT: '1 TB',
};
export const PLUS_ACCOUNT = {
  TRANSFER_LIMIT: '20 GB',
  STORAGE_LIMIT: '1 TB',
};
